<template>
    <div>
        <el-drawer
            title="导入观演人"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
            append-to-body
        >
            <div class="drawer-content">
                <el-upload
                    drag
                    action
                    :http-request="uploadExcel"
                    :auto-upload="false"
                    ref="upload"
                    accept=".xls, .xlsx"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :disabled="uploadLoading">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                    <div slot="tip" class="el-upload__tip color-danger">只能上传xls/xlsx文件，且最多不超过2W行<br>请注意：每次导入都是增量导入（不会覆盖之前导入的数据）</div>
                </el-upload>
                
                <div class="color-info">
                    导入文件示例如下:
                    <el-button 
                        v-if="$utils.have('/activityTicketWhite/downloadCommonPerformerTemplate')" 
                        type="text" 
                        icon="el-icon-download" 
                        @click="download">
                        点击下载模板
                    </el-button>
                </div>

                <div class="temp-table">
                    <el-table
                        :data="tempModel"
                        style="width: 100%"
                        size="small"
                        border
                    >
                        <el-table-column prop="id" label="证件类型"></el-table-column>                 
						<el-table-column prop="documentNumber" label="证件编号"></el-table-column>
						<el-table-column prop="telephone" label="证件姓名"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button v-if="!btnLoading" @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
                    >提交</el-button>
            </div>

            <ErrorMsgDrawer ref="errorMsgDrawer" :maxlength="20000"></ErrorMsgDrawer>     

        </el-drawer>
    </div>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    components:{ErrorMsgDrawer},
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,
            tempModel:[{
                id:'身份证',
                telephone:'张三',
				documentNumber:'5101081982828282828'
                // nickname:'张三的昵称'
            },{
                id:'护照',
                telephone:'李四',
				documentNumber:'5101081982828282828'
                // nickname:'李四的昵称'
            }],
            canSubmit:true,
            fileList:[],
            goodsId: '',
            ticketId: '',
        }
    },
    methods:{
        show(item) {
            this.goodsId = item.activityId;
            this.ticketId = item.id;
            
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        //下载模板
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/activityTicketWhite/downloadCommonPerformerTemplate',
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 &&  url){
                filePath = url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'导入观演人模板.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        onSubmit(){
            this.$refs.upload.submit();
        },
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/activityTicketWhite/importCommonPerformer',
                method: 'post',
                params:{
                    filePath:filePath,
                    activityId: this.goodsId,
                    ticketId: this.ticketId,
                }
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if( result && result.errFilePath ){
							var _path = result.errFilePath
							var _msg = `有<span class="color-danger"> ${result.totalNum} </span>名观演人导入失败，请下载后酌情修改`
                            this.$confirm(_msg, '导入观演人', {
                                
                                center: false,
                                confirmButtonText: '下载错误信息',
                                closeOnClickModal: false,
								dangerouslyUseHTMLString: true,
								showCancelButton: false,
                            }).then(()=> {
								
                                downloadFileTmp(_path,'错误观演人.'+this.$utils.getFileType(_path));
								
                            }).catch(()=> {})
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess(){
            this.$emit('onUpdate');
            this.close();
        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
::v-deep .el-upload__tip{
	color: #F56C6C;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>